<app-loader *ngIf="loader"></app-loader>
<div class="container-fluid" [ngClass]="{ 'p-0': viewType == 'mobile' }" *ngIf="!loader">
    <div [ngClass]="{ 'row justify-content-center align-items-center min-vh-100 p-2': viewType == 'desktop' }">
        <div [ngClass]="{ 'col-sm-12 col-md-8 col-lg-4 col-xl-4 col-xxl-3': viewType == 'desktop' }">
            <div class="card login-card" [ngClass]="{ 'login-card-mobile': viewType == 'mobile' }">
                <div class="row wd-100p mx-auto text-center mb-4">
                    <div class="col-md-12 col-lg-12 col-xl-12 my-auto mx-auto wd-100p">
                        <img *ngIf="logo_uri" [src]="logo_uri" width="150" height="150" class="logo-url" alt="logo" />
                    </div>
                </div>
                <div class="text-center" *ngIf="!domainCheck">
                    <h3 class="head-title">Login to your account</h3>
                    <span class="head-description">Welcome back! Select a method to login</span>
                </div>
                <div class="text-center" *ngIf="domainCheck">
                    <h3 class="head-title">Login to your account</h3>
                    <span class="head-description">Welcome back! </span>
                </div>
                <div class="card-body mt-2 pb-0">
                    <div class="alert alert-danger p-2 text-center" role="alert" *ngIf="isErrorOccured">
                        {{ errorDescription | titlecase }}
                    </div>
                    <ng-container
                        *ngIf="classicTypeLogin && classicTypeLogin.length > 1 && multipleClassicLogin == true && !showClassicalLogin && !isAuthenticationTypeValid()">
                        <ng-container *ngFor="let login of classicTypeLogin; let i = index">
                            <div class="d-grid">
                                <button (click)="selectClasicProvider(login)"
                                    class="btn btn-outline-login-type">{{login.provider_display_name}}</button>
                            </div>
                        </ng-container>
                    </ng-container>
                    
                    <ng-container *ngIf="isAuthenticationTypeValid() && domainCheck">
                                                            
                                <div>
                                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                                      <mat-form-field appearance="outline">
                                        <mat-label> Email Id </mat-label>
                                        <input matInput type="text" id="email" name="email" formControlName="email" class="form-control" autocomplete="off" />
                                      </mat-form-field>
                                      <div
                                        *ngIf="loginForm.controls['email'].invalid && (loginForm.controls['email'].dirty || loginForm.controls['email'].touched)"
                                        class="invalid-feedback">
                                        <div *ngIf="loginForm.controls['email'].errors?.['required']">Email is required.</div>
                                        <div
                                          *ngIf="!loginForm.controls['email'].errors?.['required'] && loginForm.controls['email'].errors">
                                          Enter valid email.</div>
                                      </div>
                                      <div class="d-grid" [class.cursor-not-allowed]="loginForm.invalid">
                                        <button 
                                          type="submit" 
                                          class="btn btn-hover button mt-3 d-flex align-items-center justify-content-center" 
                                          [disabled]="loginForm.controls['email'].invalid || submitLoader" 
                                          (click)="onSubmit()">
                                          <span>Continue</span>
                                          <div 
                                            class="spinner-border spinner-border-sm spinner-clr ms-2" 
                                            role="status" 
                                            *ngIf="submitLoader">
                                          </div>
                                        </button>
                                      </div>
                                      
                                      
                                    </form>
                                   </div>
                                    
                    </ng-container>
                       
                    <ng-container *ngIf="!domainCheck && (publicLoginInfo.enable_classical || showClassicalLogin)">
                        <!-- More than 1 classical provider -->
                        <div class="mt-4" *ngIf="classicTypeLogin && classicTypeLogin.length > 1">
                            <ng-container
                                *ngIf="selectedClassicalProvider && !multipleClassicLogin || showClassicalLogin">
                                <!-- Username variable -->
                                <ng-container *ngIf="selectedClassicalProvider.classical_config.username_variable">
                                    <!-- If Mobile Field -->
                                    <ng-container
                                        *ngIf="selectedClassicalProvider.classical_config.username_variable_metadata.field_type === 'MOBILE'">
                                        <ngx-intl-tel-input [cssClass]="'custom form-control'"
                                            [name]="selectedClassicalProvider.classical_config.username_variable"
                                            id="url no-increment-decrement" [(ngModel)]="userNameVar"
                                            (ngModelChange)="validateMobileInput()"
                                            [id]="selectedClassicalProvider.classical_config.username_variable"
                                            [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                                            [enablePlaceholder]="true"
                                            [customPlaceholder]="selectedClassicalProvider.classical_config.username_variable_metadata.locale_text.display_name | titlecase"
                                            [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.All]"
                                            [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                                            [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.International"
                                            [phoneValidation]="true" #usernameInput="ngModel" (keyup.enter)="onEnterPressed()">
                                        </ngx-intl-tel-input>
                                        <div class="text-danger pd-t-10">
                                            <span *ngIf="showInvalidMobileError">Please Enter the valid mobile no</span>
                                        </div>
                                    </ng-container>
                                    <!-- If not an mobile field -->
                                    <ng-container
                                        *ngIf="selectedClassicalProvider.classical_config.username_variable_metadata.field_type != 'MOBILE'">
                                        <mat-form-field appearance="outline">
                                            <mat-label>
                                                {{selectedClassicalProvider.classical_config.username_variable_metadata.locale_text.display_name
                                                |
                                                titlecase}} </mat-label>
                                                <!-- <input [(ngModel)]="userNameVar" #usernameInput="ngModel" /> -->
                                            <input matInput
                                                [type]="selectedClassicalProvider.classical_config.username_variable_metadata.field_type.toLowerCase()"
                                                [id]="selectedClassicalProvider.classical_config.username_variable"
                                                [name]="selectedClassicalProvider.classical_config.username_variable"
                                                [(ngModel)]="userNameVar" class="form-control" autocomplete="off"
                                                #usernameInput="ngModel" (keyup.enter)="onEnterPressed()" />
                                        </mat-form-field>
                                        <!-- <ng-container
                                            *ngIf="selectedClassicalProvider.classical_config.username_variable_metadata.field_type == 'EMAIL'">
                                            <div *ngIf="usernameInput.touched && usernameInput.errors"
                                                class="text-danger px-2">
                                                <small
                                                    *ngIf="usernameInput.errors['required']">{{selectedClassicalProvider.classical_config.username_variable
                                                    | titlecase}} is Mandatory.</small>
                                                <small
                                                    *ngIf="usernameInput.errors['pattern']">{{selectedClassicalProvider.classical_config.username_variable
                                                    | titlecase}} Incorrect.</small>
                                            </div>
                                        </ng-container> -->
                                        <ng-container
                                            *ngIf="selectedClassicalProvider.classical_config.username_variable_metadata.field_type == 'MOBILE'">
                                            <div *ngIf="usernameInput.touched && usernameInput.errors"
                                                class="text-danger px-2">
                                                <small
                                                    *ngIf="usernameInput.errors['required']">{{selectedClassicalProvider.classical_config.username_variable
                                                    | titlecase}} is Mandatory.</small>
                                                <small
                                                    *ngIf="usernameInput.errors['pattern']">{{selectedClassicalProvider.classical_config.username_variable
                                                    | titlecase}} Incorrect.</small>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <!-- Password variable -->
                                <ng-container *ngIf="selectedClassicalProvider.classical_config.password_variable">
                                    <div class="mb-2 mt-3">
                                        <div class="position-relative">
                                            <mat-form-field appearance="outline">
                                                <mat-label>
                                                    {{selectedClassicalProvider.classical_config.password_variable_metadata.locale_text.display_name
                                                    | titlecase}}
                                                </mat-label>
                                                <input matInput
                                                    [type]="selectedClassicalProvider.classical_config.password_variable_metadata.field_type.toLowerCase()"
                                                    [id]="selectedClassicalProvider.classical_config.password_variable"
                                                    [name]="selectedClassicalProvider.classical_config.password_variable"
                                                    [(ngModel)]="passwordVar" class="form-control" autocomplete="off"
                                                    (keyup.enter)="onEnterPressed()" />
                                            </mat-form-field>
                                            <button (click)="onClick()" class="btn icon position-absolute show-password"
                                                type="button">
                                                <img src="../../../assets/images/profile/eye.svg" alt="Logo" width="24"
                                                    height="24" *ngIf="show" />
                                                <img src="../../../assets/images/profile/visibility_off.svg" alt="Logo"
                                                    width="24" height="24" *ngIf="!show" />
                                            </button>
                                        </div>
                                        <div *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)"
                                            class="invalid-feedback">
                                            <div *ngIf="loginForm.controls['password'].errors?.['required']">
                                                {{selectedClassicalProvider.classical_config.password_variable |
                                                titlecase}} is required.</div>
                                        </div>
                                    </div>
                                </ng-container>
                                <!-- Forgot password -->
                                <div class="row justify-content-between m-0"
                                    *ngIf="publicLoginInfo?.settings?.show_forgot_password ">
                                    <div class="col text-end p-0" *ngIf="!multipleClassicLogin">
                                        <a class="forgot-password" (click)="forgotPasswordRedirect()"
                                           >Forgot
                                            Password?</a>
                                    </div>
                                </div>
                                <!-- captcha -->
                                <ng-container *ngIf="captcha.enabled">
                                    <input type="hidden" [(ngModel)]="captcha_response" name="captcha_response"
                                        id="captcha_response" class="mt-5" />
                                    <div class="form-group mt-4">
                                        <re-captcha (resolved)="resolved($event)"
                                            [siteKey]="captcha.site_key"></re-captcha>
                                        <div class="tx-danger pd-t-10"
                                            *ngIf="captcha.enabled && !captcha.verified && submitted">Captcha is
                                            required
                                        </div>
                                    </div>
                                </ng-container>
                                <!-- login button -->
                                <div class="d-grid" [class.cursor-not-allowed]="!userNameVar || !passwordVar || (captcha.enabled && !captcha.verified)">
                                    <button type="submit" class="btn btn-hover" [class.cursor-not-allowed]="!userNameVar || !passwordVar || (captcha.enabled && !captcha.verified)"
                                    (click)="onLoginSubmit()" [disabled]="!userNameVar || !passwordVar || (captcha.enabled && !captcha.verified) || submitLoader">Login <div
                                            class="spinner-border spinner-border-sm spinner-clr" role="status"
                                            *ngIf="submitLoader"></div></button>
                                </div>
                            </ng-container>
                            <div class="row text-center align-items-center mt-4">
                                <a *ngIf="!multipleClassicLogin" class="bottom-link pointer"
                                    (click)="moreLoginOption()">More login option</a>
                            </div>
                        </div>
                        <!-- Only one classical provider -->
                        <div class="mt-4" *ngIf="classicTypeLogin && classicTypeLogin.length ==  1">
                            <ng-container
                            *ngIf="(selectedClassicalProvider || showClassicalLogin)">
                            <!-- Username variable -->
                            <ng-container *ngIf="classicTypeLogin[0].classical_config.username_variable">
                                <!-- If Mobile Field -->
                                <ng-container
                                    *ngIf="classicTypeLogin[0].classical_config.username_variable_metadata.field_type === 'MOBILE'">
                                    <ngx-intl-tel-input [cssClass]="'custom form-control'" name="url"
                                        id="url no-increment-decrement" [(ngModel)]="userNameVar"
                                        (ngModelChange)="onEnterPressed()"
                                        [id]="classicTypeLogin[0].classical_config.username_variable"
                                        [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                                        [enablePlaceholder]="true" [customPlaceholder]="'Mobile Number'"
                                        [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.All]"
                                        [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                                        [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.International"
                                        [phoneValidation]="true" #usernameInput="ngModel">
                                    </ngx-intl-tel-input>
                                    <div *ngIf="usernameInput.touched && usernameInput.errors" class="text-danger px-2">
                                        <span *ngIf="showInvalidMobileError">Please Enter the valid mobile no</span>
                                    </div>
                                </ng-container>
                                <!-- If not an mobile field -->
                                <ng-container
                                    *ngIf="classicTypeLogin[0].classical_config.username_variable_metadata.field_type !== 'MOBILE'">
                                    <mat-form-field appearance="outline">
                                        <mat-label>
                                            {{classicTypeLogin[0].classical_config.username_variable_metadata.locale_text.display_name
                                            |
                                            titlecase}} </mat-label>
                                        <input matInput
                                            [type]="classicTypeLogin[0].classical_config.username_variable_metadata.field_type.toLowerCase()"
                                            [id]="classicTypeLogin[0].classical_config.username_variable"
                                            [name]="classicTypeLogin[0].classical_config.username_variable"
                                            [(ngModel)]="userNameVar" class="form-control" autocomplete="off"
                                            #usernameInput="ngModel" (keyup.enter)="onEnterPressed()" />
                                    </mat-form-field>
                                    <ng-container
                                        *ngIf="classicTypeLogin[0].classical_config.username_variable_metadata.field_type == 'EMAIL'">
                                        <div *ngIf="usernameInput.touched && usernameInput.errors"
                                            class="text-danger px-2">
                                            <small
                                                *ngIf="usernameInput.errors['required']">{{classicTypeLogin[0].classical_config.username_variable
                                                | titlecase}} is Mandatory.</small>
                                            <small
                                                *ngIf="usernameInput.errors['pattern']">{{classicTypeLogin[0].classical_config.username_variable
                                                | titlecase}} Incorrect.</small>
                                        </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="classicTypeLogin[0].classical_config.username_variable_metadata.field_type == 'MOBILE'">
                                        <div *ngIf="usernameInput.touched && usernameInput.errors"
                                            class="text-danger px-2">
                                            <small
                                                *ngIf="usernameInput.errors['required']">{{classicTypeLogin[0].classical_config.username_variable
                                                | titlecase}} is Mandatory.</small>
                                            <small
                                                *ngIf="usernameInput.errors['pattern']">{{classicTypeLogin[0].classical_config.username_variable
                                                | titlecase}} Incorrect.</small>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <!-- Password variable -->
                            <ng-container *ngIf="classicTypeLogin[0].classical_config.password_variable">
                                <div class="mb-2 mt-3">
                                    <div class="position-relative">
                                        <mat-form-field appearance="outline">
                                            <mat-label>
                                                {{classicTypeLogin[0].classical_config.password_variable_metadata.locale_text.display_name
                                                | titlecase}}
                                            </mat-label>

                                            <input matInput
                                                [type]="classicTypeLogin[0].classical_config.password_variable_metadata.field_type.toLowerCase()"
                                                [id]="classicTypeLogin[0].classical_config.password_variable"
                                                [name]="classicTypeLogin[0].classical_config.password_variable"
                                                [(ngModel)]="passwordVar" class="form-control" autocomplete="off"
                                                (keyup.enter)="onEnterPressed()" />
                                        </mat-form-field>
                                        <button (click)="onClickOne()" class="btn icon position-absolute show-password"
                                            type="button">
                                            <img src="../../../assets/images/profile/eye.svg" alt="Logo" width="24"
                                                height="24" *ngIf="show" />
                                            <img src="../../../assets/images/profile/visibility_off.svg" alt="Logo"
                                                width="24" height="24" *ngIf="!show" />
                                        </button>
                                    </div>
                                    <div *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)"
                                        class="invalid-feedback">
                                        <div *ngIf="loginForm.controls['password'].errors?.['required']">
                                            {{selectedClassicalProvider.classical_config.password_variable |
                                            titlecase}} is required.</div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- Forgot password -->
                            <div class="row justify-content-between m-0"
                                *ngIf="publicLoginInfo?.settings?.show_forgot_password ">
                                <div class="col text-end p-0" *ngIf="!multipleClassicLogin">
                                    <a class="forgot-password" (click)="forgotPasswordRedirect()">Forgot
                                        Password?</a>
                                </div>
                            </div>
                            <!-- captcha -->
                            <ng-container *ngIf="captcha.enabled">
                                <input type="hidden" [(ngModel)]="captcha_response" name="captcha_response"
                                    id="captcha_response" class="mt-5" />
                                <div class="form-group mt-4">
                                    <re-captcha (resolved)="resolved($event)" [siteKey]="captcha.site_key"></re-captcha>
                                    <div class="tx-danger pd-t-10"
                                        *ngIf="captcha.enabled && !captcha.verified && submitted">Captcha is required
                                    </div>
                                </div>
                            </ng-container>
                            <!-- login button -->
                            <div class="d-grid" [class.cursor-not-allowed]="!userNameVar || !passwordVar || (captcha.enabled && !captcha.verified)">
                                <button type="submit" class="btn btn-hover" [class.cursor-not-allowed]="!userNameVar || !passwordVar || (captcha.enabled && !captcha.verified)"
                                    (click)="onLoginSubmit()" [disabled]="!userNameVar || !passwordVar || (captcha.enabled && !captcha.verified) || submitLoader">Login <div
                                        class="spinner-border spinner-border-sm spinner-clr" role="status"
                                        *ngIf="submitLoader"></div></button>
                            </div>
                        </ng-container>
                        </div>
                    </ng-container>

                     <ng-container *ngIf="!domainCheck" >
                    <div *ngIf="passwordlessLogin && passwordlessLogin.length > 0">
                        <div class="row text-center align-items-center mt-4">
                            <p class="bottom-description mb-3">
                                Signin as a
                                <a class="bottom-link" [routerLink]="['/passwordless']"
                                    [queryParams]="{ request_id: queryParams.request_id, client_id: queryParams.client_id, provider_name: queryParams.provider_name, provider_type: queryParams.provider_type }">passwordless
                                    login?</a>
                            </p>
                        </div>
                    </div>
                    <ng-container
                        *ngIf="(classicTypeLogin && classicTypeLogin.length > 0) && (providerLogin && providerLogin.length > 0)">
                        <div class="divider"
                            *ngIf="publicLoginInfo?.login_providers && publicLoginInfo?.login_providers.length > 0 && publicLoginInfo.enable_classical">
                            or login with
                        </div>
                    </ng-container>

                    <ng-container
                        *ngIf="!(classicTypeLogin && classicTypeLogin.length > 0) && (passwordlessLogin && passwordlessLogin.length > 0) && (providerLogin && providerLogin.length > 0)">
                        <div class="divider">
                            or login with
                        </div>
                    </ng-container>

                    <div class="mx-auto row text-center" *ngIf="providerLogin && providerLogin.length > 0">
                        <ng-container *ngIf="providerLogin">
                            <div class="col gx-3">
                                <ng-container *ngFor="let provider of providerLogin; trackBy: trackByFn">
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'google'">
                                        <img src="assets/images/google.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'linkedin'">
                                        <img src="assets/images/linkedin.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'facebook'">
                                        <img src="assets/images/facebook.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'github'">
                                        <img src="assets/images/github.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'amazon'">
                                        <img src="assets/images/amazon.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'paypal_sandbox'">
                                        <img src="assets/images/paypal_sandbox.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'salesforce'">
                                        <img src="assets/images/salesforce.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'wordpress'">
                                        <img src="assets/images/wordpress.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'yahoo'">
                                        <img src="assets/images/yahoo.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'twitter'">
                                        <img src="assets/images/twitter.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'foursquare'">
                                        <img src="assets/images/foursquare.svg" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="provider.provider_name == 'office365'">
                                        <img src="assets/images/office-365.png" alt="Logo" width="35" height="35" />
                                    </button>
                                    <button (click)="loginWithSaml(provider.provider_name)"
                                        [title]="provider.provider_name" class="btn" type="button"
                                        *ngIf="provider.provider_name == 'SAML'">
                                        <ng-container *ngIf="provider.logo_uri && provider.logo_uri != ''">
                                            <img [src]="provider.logo_uri" alt="" style="height: 30px; width: auto" />
                                        </ng-container>
                                        <ng-container
                                            *ngIf="(provider.logo_uri && provider.logo_uri == '') || !provider.logo_uri">
                                            <img src="https://skillmine-auth-admin.firebaseapp.com/assets/img/brand/logo_symbol.png"
                                                alt="logo" style="height: 30px; width: auto" width="35" height="35" />
                                        </ng-container>
                                    </button>
                                    <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name"
                                        class="btn" type="button" *ngIf="
                      provider.provider_name != 'SAML' &&
                      provider.provider_name != 'google' &&
                      provider.provider_name != 'office365' &&
                      provider.provider_name != 'foursquare' &&
                      provider.provider_name != 'facebook' &&
                      provider.provider_name != 'twitter' &&
                      provider.provider_name != 'linkedin' &&
                      provider.provider_name != 'github' &&
                      provider.provider_name != 'amazon' &&
                      provider.provider_name != 'yahoo' &&
                      provider.provider_name != 'salesforce' &&
                      provider.provider_name != 'wordpress' &&
                      provider.provider_name != 'paypal_sandbox'
                    ">
                                        <ng-container *ngIf="provider.logo_uri && provider.logo_uri != ''">
                                            <img [src]="provider.logo_uri" alt="logo" style="height: 30px; width: auto"
                                                width="35" height="35" />
                                        </ng-container>
                                        <ng-container
                                            *ngIf="(provider.logo_uri && provider.logo_uri == '') || !provider.logo_uri">
                                            <img src="https://skillmine-auth-admin.firebaseapp.com/assets/img/brand/logo_symbol.png"
                                                alt="logo" style="height: 30px; width: auto" width="35" height="35" />
                                        </ng-container>
                                    </button>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                    <div class="row text-center align-items-center mt-4">
                        <p class="bottom-description mb-3" *ngIf="is_federation_login">
                            Signin as a
                            <a class="bottom-link" [routerLink]="['/federation-login']"
                                [queryParams]="{ request_id: queryParams.request_id, client_id: queryParams.client_id, provider_name: queryParams.provider_name, provider_type: queryParams.provider_type }">federation
                                login?</a>
                        </p>
                        <!-- <p class="bottom-description mb-3" *ngIf="isPasswordlessEnabled">
                            Signin as a
                            <a class="bottom-link" [routerLink]="['/passwordless']"
                                [queryParams]="{ request_id: queryParams.request_id, client_id: queryParams.client_id, provider_name: queryParams.provider_name, provider_type: queryParams.provider_type }">passwordless
                                login?</a>
                        </p> -->
                        <p class="bottom-description mb-3" *ngIf="isRegisterEnabled">
                            Don’t have an account?
                            <a class="bottom-link" [routerLink]="['/register']"
                                [queryParams]="{ request_id: queryParams.request_id, client_id: queryParams.client_id, provider_name: queryParams.provider_name, provider_type: queryParams.provider_type }">Create
                                an account</a>
                        </p>
                    </div>
                </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Location Permission Modal -->
<div class="modal fade" id="locationModal" tabindex="-1" role="dialog" aria-labelledby="locationModalLabel" aria-hidden="true" #locationModal>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content rounded-4 shadow-sm border-0">
      <div class="modal-header border-0">
        <h5 class="modal-title fw-semibold" id="locationModalLabel">Location Permission Required</h5>
        <!-- <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" style="background: none; border: none;">
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <div class="modal-body text-secondary fs-6">
        This application requires access to your location to function properly. Please grant permission to access your location.
      </div>
      <div class="modal-footer border-0">
        <!-- <button type="button" class="btn btn-light rounded-pill px-4" data-dismiss="modal">Deny</button> -->
        <button type="button" class="btn rounded-pill px-4 text-white" style="background-color: #0162e8;" (click)="getLocation()">Allow</button>
      </div>
    </div>
  </div>
</div>